import { ArrowUpOutlined, ArrowDownOutlined, EnterOutlined } from '@ant-design/icons';
import { T, useTranslate } from '@tolgee/react';

export const PhraseToolbar = ({
  mercadoQAmode,
  hotkeyEnable = true,
}: {
  mercadoQAmode?: boolean;
  hotkeyEnable?: boolean;
}) => {
  const { t } = useTranslate();

  if (!hotkeyEnable) {
    return (
      <div className="inline-flex items-center gap-2">
        <div className="text-xs text-content-200">
          {t('scene.chatWorkspace.quickReply.hint.tabToActivateShortcut')}
        </div>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2">
      <div className="text-xs text-content-200">
        <span>1.</span>
        {
          <T
            keyName="chat_phrase_toolbar_tips1"
            params={{
              x: (
                <>
                  <ArrowUpOutlined />
                  <ArrowDownOutlined />
                </>
              ),
            }}
          />
        }
      </div>
      <div className="text-xs text-content-200">
        <span>2.</span>
        {mercadoQAmode ? (
          ['[', <EnterOutlined />, ']', t('reply.应用')]
        ) : (
          <T
            keyName="chat_phrase_toolbar_tips2"
            params={{
              x: <EnterOutlined />,
            }}
          />
        )}
      </div>
    </div>
  );
};
